import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
export default function Dropdown({ children }) {
    return (
        <RadixDropdownMenu.Root  >  {children} </RadixDropdownMenu.Root>
    );
}

function DropdownButton({ children, className }) {
    return (
        <RadixDropdownMenu.Trigger className={`inline-flex   items-center  justify-center rounded-full  focus:outline-none outline-none ${className}`}
            aria-label="Customise options">
            {children}
        </RadixDropdownMenu.Trigger>
    );
}

Dropdown.Button = DropdownButton;


function DropdownMenu({ children, align = 'start' }) {
    return (
        <RadixDropdownMenu.Portal  >
            <RadixDropdownMenu.Content
                className="min-w-[150px] z-[11]  rdx_content shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),_0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]"
                sideOffset={5}
                align={align}
                collisionPadding={{ top: 20, left: 20, right: 20 }}
            // asChild
            >
                {children}
                <RadixDropdownMenu.Arrow className="rdx_arrow" />

            </RadixDropdownMenu.Content>
        </RadixDropdownMenu.Portal>

    );
}

Dropdown.Menu = DropdownMenu;


function DropdownMenuItem({ children, onSelect, className, disabled, ...props }) {
    if (typeof children === "string") {
        return (
            <RadixDropdownMenu.Item className={className} onSelect={onSelect} asChild   >
                <button {...props} disabled={disabled} >{children}</button>
            </RadixDropdownMenu.Item>
        );
    } else {
        return (
            <>
                {children}
            </>

        )
    }

}

Dropdown.MenuItem = DropdownMenuItem;

// usage


//   <div className='flex items-center h-full'>
//             <Dropdown>
//               <Dropdown.Button><BiDotsVerticalRounded size={22} /></Dropdown.Button>
//               <Dropdown.Menu>
//                 <Dropdown.MenuItem className="group rdx_item"  >
//                   Item 1
//                 </Dropdown.MenuItem>
//                 <Dropdown.MenuItem className="group rdx_item"  >
//                   Item 33464545
//                 </Dropdown.MenuItem>
//                 <Dropdown.MenuItem  >
//                   <RadixDropdownMenu.Sub>
//                     <RadixDropdownMenu.SubTrigger className="group rdx_item rdx_subtrigger ">
//                       More Tools
//                       <div className="ml-auto pl-5 text-mauve11 group-data-[disabled]:text-mauve8 group-data-[highlighted]:text-white">
//                         <RxChevronRight />
//                       </div>
//                     </RadixDropdownMenu.SubTrigger>
//                     <RadixDropdownMenu.Portal>
//                       <RadixDropdownMenu.SubContent
//                         className="min-w-[180px]  z-[9999] rdx_content shadow-[0px_10px_38px_-10px_rgba(22,23,_24,_0.35),_0px_10px_20px-15px_rgba(22,_23,_24,_0.2)] "
//                         sideOffset={2}
//                         alignOffset={-5}
//                       >

//                         <Dropdown.MenuItem className="group rdx_item"  >
//                           Item subbb
//                         </Dropdown.MenuItem>
//                         <RadixDropdownMenu.Separator className="rdx_seperator" />
//                         <RadixDropdownMenu.Item className="group rdx_item">
//                           New Tab
//                           <div className="ml-auto pl-5 text-mauve11 group-data-[disabled]:text-black group-data-[highlighted]:text-[#FFFFFF]">
//                             ⌘+T
//                           </div>
//                         </RadixDropdownMenu.Item>
//                       </RadixDropdownMenu.SubContent>
//                     </RadixDropdownMenu.Portal>
//                   </RadixDropdownMenu.Sub>
//                 </Dropdown.MenuItem>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>